module.exports = __webpack_public_path__ + "img/cra.b57b443d.svg";